const FullHeaderHero = {
  parts: [
    'container',
    'backgroundImage',
    'overlay',
    'content',
    'saleInfo',
    'textContainer',
    'title',
    'subtitle',
    'buttonGroup',
    'primaryButton',
    'secondaryButton'
  ],
  baseStyle: {
    container: {
      position: 'relative',
      width: 'full',
      height: '100vh',
      minHeight: '810px',
      display: 'flex',
      alignItems: 'flex-end',
      overflow: 'hidden',
    },
    backgroundImage: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 'full',
      height: 'full',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      zIndex: 1,
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 'full',
      height: 'full',
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.30) 55.31%)',
      zIndex: 2,
    },
    content: {
      position: 'relative',
      zIndex: 3,
      width: 'full',
      maxWidth: '1440px',
      mx: 'auto',
      px: {base: 5, md: 20},
      pb: {base: 10, md: 20},
      pt: {base: 5, md: 0},
      pl: {base: 5, md: 20, lg: 32},
    },
    saleInfo: {
      display: 'flex',
      width: {base: 'full', md: '448px'},
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 4.5, md: 8},
      mt: 0,
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 4.5, md: 5},
      alignSelf: 'stretch',
    },
    title: {
      alignSelf: 'stretch',
      color: 'white',
      fontFamily: 'heading',
      fontSize: {base: '40px', md: '5xl', lg: '6xl'},
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: {base: '100%', md: '120%'},
      letterSpacing: {base: '-0.01em', md: '-0.015em', lg: '-0.01em'},
      mb: 0,
    },
    subtitle: {
      alignSelf: 'stretch',
      color: 'white',
      fontFamily: 'body',
      fontSize: {base: 'md', lg: 'lg'},
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '160%',
    },
    buttonGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: {base: 2, md: 4},
      flexDirection: 'row',
      flexWrap: {base: 'wrap', md: 'nowrap'},
      width: 'full',
    },
    primaryButton: {
      display: 'flex',
      height: {base: 13.5, md: 13.5},
      py: {base: 3.5, md: 4},
      px: 8,
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      borderRadius: 'sm',
      backgroundColor: 'white',
      color: 'brandColors.greyscale',
      fontFamily: 'body',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      flex: {base: '0 0 100%', md: 'none'},
      minWidth: 0,
      _hover: {
        background: 'whiteAlpha.900',
        boxShadow: 'md',
      },
      sx: {
        ' svg': {
          width: 4,
          height: 4,
        },
      },
    },
    secondaryButton: {
      display: 'flex',
      height: {base: 13.5, md: 13.5},
      py: {base: 3.5, md: 4},
      px: 12,
      justifyContent: 'center',
      alignItems: 'center',
      gap: {base: 1.5, md: 2},
      borderRadius: 'base',
      border: '1px solid white',
      backgroundColor: 'transparent',
      color: 'white',
      fontFamily: 'body',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      flex: {base: '0 0 100%', md: 'none'},
      minWidth: 0,
      _hover: {
        background: 'whiteAlpha.250',
        borderColor: 'whiteAlpha.800',
      },
      _active: {
        background: 'whiteAlpha.150',
      },
    },
  },
};

export default FullHeaderHero;
